import { useEffect, useState } from "react";
import { Box, Icon, Text } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import { Accordion } from "~components/common/Accordion";
import { Button } from "~components/common/Button";
import { Cross } from "~components/common/Icons";
import { NhAccordion } from "~components/common/Story/NhComponents/NhAccordion";
import { CategoriesAccordion } from "./CategoriesAccordion";
import { RecipesSearchBar } from "./RecipesSearchBar";
import { Tags } from "./TagsFilters";
import TagsFilterContent from "./TagsFilterСontent";

interface MobileFilters {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  tags: Tags[];
  categories: any;
}

const TagsMobile: React.FC<MobileFilters> = ({
  isOpen,
  setIsOpen,
  tags,
  categories,
}) => {
  // const [isClosed, setIsClosed] = useState<boolean>(false);
  const [open, setOpen] = useState(0);
  const router = useRouter();
  // useEffect(() => {
  //   if (isOpen) setIsClosed(false);
  // }, [isOpen]);
  const hasFilters = router?.query?.category || router?.query?.tags;
  return (
    <Box
      p={"14px"}
      m={0}
      display={isOpen ? "flex" : "none"}
      flexDirection="column"
      position="fixed"
      width="100%"
      height="100%"
      backgroundColor="#FBF7F3CC"
      top={0}
      css={{ "backdrop-filter": "blur(28px)" }}
      left={0}
      zIndex={999999}
      overflowY="scroll"
    >
      <Box
        borderBottom="1px solid grey200"
        alignItems="center"
        mb={3}
        display={"flex"}
        justifyContent={"center"}
        height={"61px"}
        position={"relative"}
      >
        <Icon
          icon={Cross}
          onClick={() => setIsOpen(false)}
          position="absolute"
          right={0}
          cursor="pointer"
          fontSize={4}
        />
        <Text fontSize={"24px"} fontFamily={"DINPro"} fontWeight={700}>
          Filters
        </Text>
      </Box>
      <RecipesSearchBar />
      <Box mt={1}>
        <CategoriesAccordion categories={categories} />
        {tags.map(({ title, tags }, i) => (
          <Box
            key={title}
            onClick={(e) => {
              e.stopPropagation();
              if (open === i) setOpen(null);
              else setOpen(i);
            }}
          >
            <NhAccordion
              close={i !== open}
              isFirst={!i}
              title={title}
              key={title}
              isTags
              tags={tags}
            >
              <TagsFilterContent title={title} tags={tags} />
            </NhAccordion>
          </Box>
        ))}
      </Box>

      <Box
        display="flex"
        mt={"34px"}
        alignItems="center"
        justifyContent={"center"}
      >
        <Box
          width="max-content"
          opacity={hasFilters ? 1 : 0.5}
          borderBottom={"1px solid black"}
          lineHeight={"22.4px"}
          fontWeight={500}
          color={"#1D1D1B"}
          cursor={hasFilters ? "pointer" : "not-allowed"}
          onClick={() => {
            // setIsClosed(true);
            if (hasFilters)
              router.push(router.pathname, undefined, { shallow: true });
          }}
        >
          Reset Filters
        </Box>
      </Box>
    </Box>
  );
};

export default TagsMobile;
